/**
 * Mobile tab bar (Reppr Elite mobile, v2 handoff).
 *
 * Design rule 05: four destinations, never five — Desk, Book, Pipeline, Log.
 * Rule 08: Quick log is reachable from every screen via the tab bar and is the
 * only create surface on a phone.
 *
 * Everything outside these four (settings, contacts, compliance, finance…) is
 * reached from the mobile header's menu, NOT from a fifth tab: the app renders
 * no sidebar under 768px, so that menu is the only route to those screens.
 */

import { NavLink } from 'react-router-dom'
import { useQuickLog } from '../hooks/useQuickLog'
import styles from './MobileBottomNav.module.css'

export default function MobileBottomNav() {
  const { open: openQuickLog } = useQuickLog()

  return (
    <nav className={styles.bottomNav} aria-label="Primary">
      <NavLink
        to="/dashboard"
        className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
      >
        <div className={styles.navIcon}><DeskIcon /></div>
        <span className={styles.navLabel}>Desk</span>
      </NavLink>

      <NavLink
        to="/clients"
        className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
      >
        <div className={styles.navIcon}><BookIcon /></div>
        <span className={styles.navLabel}>Book</span>
      </NavLink>

      <NavLink
        to="/deals"
        className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
      >
        <div className={styles.navIcon}><PipelineIcon /></div>
        <span className={styles.navLabel}>Pipeline</span>
      </NavLink>

      <button className={styles.navItem} onClick={openQuickLog} aria-label="Quick log">
        <div className={styles.navIcon}><MicIcon /></div>
        <span className={styles.navLabel}>Log</span>
      </button>
    </nav>
  )
}

/* Icons match the handoff's mobile set: 21px, 1.5 stroke, currentColor. */

function DeskIcon() {
  return (
    <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="7" height="9" />
      <rect x="14" y="3" width="7" height="5" />
      <rect x="14" y="12" width="7" height="9" />
      <rect x="3" y="16" width="7" height="5" />
    </svg>
  )
}

function BookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
      <path d="M9 7h6M9 11h4" />
    </svg>
  )
}

function PipelineIcon() {
  return (
    <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M2 4h20l-7 8v8l-6-2v-6z" />
    </svg>
  )
}

function MicIcon() {
  return (
    <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
      <path d="M19 11v1a7 7 0 0 1-14 0v-1" />
      <line x1="12" y1="19" x2="12" y2="22" />
    </svg>
  )
}
